// ecommerce-frontend/src/App.jsx

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Pages principales
import HomePage from './pages/HomePage';
import ProductDetail from './pages/ProductDetail';
import CartPage from './pages/CartPage';
import Checkout from './pages/Checkout';
import AboutPage from './pages/AboutPage';        // ✅ NOUVEAU
import CGUPage from './pages/CGUPage';            // ✅ NOUVEAU
import HelpPage from './pages/HelpPage';          // ✅ NOUVEAU

// Authentification
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

// Profil utilisateur
import ProfileEditPage from './pages/ProfileEditPage';
import FavoritesPage from './pages/FavoritesPage';
import OrdersPage from './pages/OrdersPage'; 

// Dashboards
import BuyerDashboard from './pages/BuyerDashboard';
import VendorDashboard from './pages/VendorDashboard';

// Pages vendeur
import AddProductPage from './pages/vendor/AddProductPage';
import EditProductPage from './pages/vendor/EditProductPage';

function App() {
  return (
    <Router>
      <Routes>
        {/* Routes publiques */}
        <Route path="/" element={<HomePage />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/about" element={<AboutPage />} />           {/* ✅ NOUVEAU */}
        <Route path="/cgu" element={<CGUPage />} />               {/* ✅ NOUVEAU */}
        <Route path="/help" element={<HelpPage />} />             {/* ✅ NOUVEAU */}
        
        {/* Authentification */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        
        {/* Pages acheteur */}
        <Route path="/cart" element={<CartPage />} />
        <Route path="/buyer/dashboard" element={<BuyerDashboard />} />
        <Route path="/orders" element={<OrdersPage />} /> 
        <Route path="/favorites" element={<FavoritesPage />} />
        <Route path="/profile/edit" element={<ProfileEditPage />} />
        <Route path="/checkout" element={<Checkout />} />
        
        {/* Pages vendeur */}
        <Route path="/vendor/dashboard" element={<VendorDashboard />} />
        <Route path="/vendor/add-product" element={<AddProductPage />} />
        <Route path="/vendor/edit-product/:id" element={<EditProductPage />} />
      </Routes>
    </Router>
  );
}

export default App;